export default __webpack_public_path__ + "static/media/iron-sights.1be343ec.svg";